export const SET_HAPPINESS_TIPS_CATEGORIES = "SET_HAPPINESS_TIPS_CATEGORIES";
export const SET_HAPPINESS_TIPS_CATEGORIES_DELETE = "SET_HAPPINESS_TIPS_CATEGORIES_DELETE";
